import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, Observable } from 'rxjs';

import { User } from '../../entities/user.entity';
import { API_BASE_URL } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  /**
   * Auth Events
   *
   * @static
   * @memberof AuthService
   */
  static Events = {
    Login: new EventEmitter<Authorization>(),
    Unauthorized: new EventEmitter(),
    Logout: new EventEmitter()
  };


  constructor(
    private http: HttpClient
  ) { }

  /**
   * Auth Login
   *
   * @param {LoginData} [user=null]
   * @returns {Observable<Object>}
   * @memberof AuthService
   */
  async login(user: LoginData): Promise<Authorization> {

    const authorization = await lastValueFrom(this.http.post<any>(API_BASE_URL + '/login', user));

    localStorage.setItem('authorization', JSON.stringify(authorization));

    AuthService.Events.Login.emit(authorization);

    return authorization;

  }


  logout() {
    AuthService.Events.Logout.emit();
    localStorage.removeItem('authorization');
  }

  getAuthorization(): Authorization {
    const authorizationStorage = localStorage.getItem('authorization');
    let authorization = null;
    if (authorizationStorage) {
      authorization = Object.assign(new Authorization(), JSON.parse(authorizationStorage));
    }
    return authorization;
  }

}


export class Authorization {

  /**
   * Token Access
   *
   * @type {string}
   * @memberof Authorization
   */
  token: string;

  /**
   * User data
   *
   * @type {*}
   * @memberof Authorization
   */
  user: User;
}


export interface LoginData {

  /**
   * User username
   *
   * @type {string}
   * @memberof LoginData
   */
  email: string;

  /**
   * User password
   *
   * @type {string}
   * @memberof LoginData
   */
  password: string;
}
